import React, { useState, useEffect } from "react";
import { useCart } from "../../context/CartContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Header } from "../../header";
import { useNotify } from "tailwind-notifications-react";
import { Footer } from "../../components/footer";
import AsyncSelect from "react-select/async";
import { debounce } from "lodash";

import policy from '../../files/alyonashvetspolicy.doc'
import oferta from '../../files/oferta.RTF'

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export const CartPage = () => {
  const downloadFile = (doc, name) => {
    const link = document.createElement('a');
    link.href = doc;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const { cartItems, updateCartItem, removeCartItem } = useCart();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [deliveryDays, setDeliveryDays] = useState([]);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isDeliveryCostLoading, setIsDeliveryCostLoading] = useState(false);
  const [removedItems, setRemovedItems] = useState([]);
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [quantityLoading, setQuantityLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponData, setCouponData] = useState(null);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [couponError, setCouponError] = useState("");  
  const [formData, setFormData] = useState({
    initials: "",
    phone: "",
    country: "",
    city: "",
    address: "",
    email: "",
    deliveryPoint: "",
    apartment: "",
    floor: "",
  });
  const [formDataCourier, setFormDataCourier] = useState({
    address: "",
    apartment: "",
    floor: "",
  });
  const [formDataPickup, setFormDataPickup] = useState({
    deliveryPoint: "",
  });
  const [deliveryMethod, setDeliveryMethod] = useState("136");
  const [deliveryCost, setDeliveryCost] = useState(null);
  const [pickupPoints, setPickupPoints] = useState([]);
  const [cityID, setCityID] = useState("");
  const notify = useNotify();
  const clearCart = async () => {
    localStorage.setItem("cart", []);
  };

  document.title = "Корзина | Магазин Алёны Швец";
  
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://api.alyonatestsite.store/api/products");
        const allProducts = response.data;
        setAllProducts(allProducts);
  
        let updatedCart = [];
        let removed = [];
  
        cartItems.forEach((cartItem) => {
          const product = allProducts.find((p) => p.id === cartItem.id);
  
          if (!product) {
            removed.push(cartItem.name);
            removeCartItem(cartItem.id, cartItem.size);
          } 
          else if (cartItem.size) {
            const sizeData = product.sizes?.find((s) => s.name === cartItem.size);
  
            if (!sizeData || sizeData.quantity < cartItem.quantity) {
              removed.push(`${cartItem.name} (${cartItem.size})`);
              removeCartItem(cartItem.id, cartItem.size);
            } 
            else {
              updatedCart.push({ ...cartItem, ...product });
            }
          } 
          else if (product.stock >= cartItem.quantity) {
            updatedCart.push({ ...cartItem, ...product });
          } 
          else {
            removed.push(cartItem.name);
            removeCartItem(cartItem.id, cartItem.size);
          }
        });
  
        setProducts(updatedCart);
  
        if (removed.length > 0) {
          setRemovedItems(removed);
          setModalOpen(true);
        }
      } catch (err) {
        console.error("Ошибка загрузки товаров:", err);
      }
    };
  
    if (cartItems.length > 0) {
      fetchProducts();
    }
  }, [cartItems, removeCartItem]);
  
  const sortByPickupCode = (a, b) => {
  const regex = /^([A-Za-z]+)(\d+)$/;

  const [, aLetters, aDigits] = a.code.match(regex) || [];
  const [, bLetters, bDigits] = b.code.match(regex) || [];

  if (aLetters !== bLetters) return aLetters.localeCompare(bLetters);
  return Number(aDigits) - Number(bDigits);
};
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const totalAmount = products.reduce(
    (sum, item) =>
      sum +
      parseFloat(item.discount && item.discount > 0 ? item.discount : item.price) *
      item.quantity,
    0
  );
  const finalAmount = totalAmount - discountAmount + (deliveryCost || 0);
  const handlePayment = async () => {
    setIsPaymentLoading(true);
  
    if (!validatePhone(formData.phone)) {
      notify({
        title: "Ошибка",
        message: "Пожалуйста, введите корректный номер телефона",
        type: "error",
      });
      setIsPaymentLoading(false);
      return;
    }
  
    if (!validateEmail(formData.email)) {
      notify({
        title: "Ошибка",
        message: "Пожалуйста, введите корректный адрес электронной почты",
        type: "error",
      });
      setIsPaymentLoading(false);
      return;
    }
  
    if (totalAmount < 600) {
      notify({
        title: "Ошибка",
        message: "Минимальная сумма заказа 600 рублей без учёта стоимости доставки.",
        type: "error",
      });
      setIsPaymentLoading(false);
      return;
    }

    if (deliveryCost === null || deliveryCost < 100) {
      notify({
        title: "Ошибка",
        message: "Стоимость доставки не определена. Пожалуйста, проверьте данные доставки.",
        type: "error",
      });
      setIsPaymentLoading(false);
      return;
    }
  
    try {
      const response = await axios.get("https://api.alyonatestsite.store/api/products");
      const allProducts = response.data;
  
      let updatedCart = [];
      let removed = [];
  
      cartItems.forEach((cartItem) => {
        const product = allProducts.find((p) => p.id === cartItem.id);
  
        if (!product) {
          removed.push(cartItem.name);
          removeCartItem(cartItem.id, cartItem.size);
        } 
        else if (cartItem.size) {
          const sizeData = product.sizes?.find((s) => s.name === cartItem.size);
  
          if (!sizeData || sizeData.quantity < cartItem.quantity) {
            removed.push(`${cartItem.name} (${cartItem.size})`);
            removeCartItem(cartItem.id, cartItem.size);
          } 
          else {
            updatedCart.push({ ...cartItem, ...product });
          }
        } 
        else if (product.stock >= cartItem.quantity) {
          updatedCart.push({ ...cartItem, ...product });
        } 
        else {
          removed.push(cartItem.name);
          removeCartItem(cartItem.id, cartItem.size);
        }
      });
  
      if (removed.length > 0) {
        setRemovedItems(removed);
        setModalOpen(true);
        setIsPaymentLoading(false); 
        return;
      }

      const orderItems = cartItems.map((cartItem) => {
        const product = allProducts.find((p) => p.id === cartItem.id);
        return {
          id: cartItem.id,
          size: cartItem.size,
          quantity: cartItem.quantity,
          name: product?.name || "Неизвестный товар",
          price: product?.discount && product?.discount > 0 ? product?.discount : product?.price,
          images: product?.images || [],
          sku: product?.sku || `product_${cartItem.id}`,
          weight: product?.weight || 0.2,
        };
      });
  
      const paymentResponse = await axios.post(
        "https://api.alyonatestsite.store/api/create-payment",
        {
          email: formData.email,
          initials: formData.initials,
          amount: finalAmount,
          cart: orderItems,
          delivery: deliveryCost
        }
      );
      const { metadata, confirmation, id } = paymentResponse.data;
  
      await axios.post("https://api.alyonatestsite.store/api/order", {
        id: metadata.id,
        cart: orderItems,
        initials: formData.initials,
        phone: formData.phone,
        email: formData.email,
        amount: finalAmount,
        coupon: couponData?.name,
        couponAmount: discountAmount,
        deliveryType: deliveryMethod,
        deliveryAmount: deliveryCost,
        paymentURL: confirmation.confirmation_url,
        invoiceID: id,
        address: formData.address,
        cdekPoint: formData.deliveryPoint,
      });
  
      window.location.href = confirmation.confirmation_url;
    } catch (error) {
      console.error("Ошибка при создании платежа:", error);
      notify({
        title: "Ошибка",
        message: "Произошла ошибка при создании платежа. Пожалуйста, попробуйте ещё раз.",
        type: "error",
      });
      setIsPaymentLoading(false);
    }
  };
  const handleAddressSearch = async (inputValue) => {
    if (!inputValue) return [];
    try {
      const response = await axios.post(
        "https://api.alyonatestsite.store/api/addresses",
        { query: inputValue });
      return response.data.suggestions.map((suggestion) => ({
        value: suggestion.data,
        label: suggestion.value,
      }));
    } catch (error) {
      console.error("Error fetching address suggestions:", error);
      return [];
    }
  };
  const debouncedAddressSearch = debounce(handleAddressSearch, 300);
  const fetchDeliveryPoints = async () => {
    const { city } = formData;
    if (!city) {
      return;
    }
    try {
      const response = await axios.post(
        "https://api.alyonatestsite.store/api/get-point",
        { cityName: city },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setCityID(response.data[0].location.city_code);
      setPickupPoints(response.data);
    } catch (error) {
      console.error("Ошибка получения пунктов выдачи:", error);
    }
  };
  const debouncedCalculateDeliveryCost = debounce(async (tariffCode, cityID, formData, cartItems) => {
    setIsDeliveryCostLoading(true);
    const totalWeight = cartItems.reduce(
      (sum, item) => sum + (item.weight * 1000) || 0.2,
      0
    );
    const requestData = {
      type: 1,
      tariff_code: tariffCode,
      from_location: {
        code: 44,
        city: "Москва",
        address: "г. Москва, ул. Ярославская, д. 8 корп. 5, офис 409",
      },
      to_location: {
        code: cityID,
        address: formData.address,
      },
      packages: [
        {
          height: 10,
          length: 10,
          weight: totalWeight,
          width: 10,
        },
      ]
    };
    try {
      const response = await axios.post('https://api.alyonatestsite.store/api/calculate-delivery', requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setDeliveryCost(response.data.total_sum + 50 + Math.round((totalAmount / 100)));
      setDeliveryDays([response.data.calendar_min, response.data.calendar_max]);
    } catch (err) {
      console.error("Ошибка при расчете стоимости доставки:", err);
    } finally {
      setIsDeliveryCostLoading(false);
    }
  }, 500);
  useEffect(() => {
    if (formData.city && deliveryMethod === "136") {
      fetchDeliveryPoints();
    }
    if ((deliveryMethod === "137" && formData.address && cityID) || (deliveryMethod === "136" && cityID)) {
      debouncedCalculateDeliveryCost(deliveryMethod, cityID, formData, cartItems);
    }
  }, [formData.city, formData.address, cityID, deliveryMethod, cartItems]);
  useEffect(() => {
    if (!couponData) {
      setDiscountAmount(0);
      return;
    }
  
    let discount = 0;
    const discountPercent = Number(couponData.discount) || 0;
  
    if (couponData.appliesToAll) {
      discount = totalAmount * (discountPercent / 100);
    } else if (couponData.products && couponData.products.length > 0) {
      discount = products.reduce((sum, item) => {
        if (couponData.products.includes(item.id)) {
          const price = item.discount && item.discount > 0 ? item.discount : item.price;
          return sum + price * item.quantity * (discountPercent / 100);
        }
        return sum;
      }, 0);
    }

    setDiscountAmount(discount);
  }, [couponData, products, totalAmount]);
  
  const handleDeliveryMethodChange = (e) => {
    const method = e.target.value;
    setDeliveryMethod(method);
    if (method === "137") {
      setFormDataPickup((prev) => ({ ...prev, deliveryPoint: formData.deliveryPoint }));
    } else {
      setFormDataCourier((prev) => ({ ...prev, address: formData.address, apartment: formData.apartment, floor: formData.floor }));
    }
    if (method === "136") {
      setFormData((prev) => ({ ...prev, ...formDataPickup }));
    } else {
      setFormData((prev) => ({ ...prev, ...formDataCourier }));
    }
  };
  const validatePhone = (phone) => {
    const phoneRegex = /^\+?[0-9]{10,15}$/;
    return phoneRegex.test(phone);
  };

  const applyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError("Введите код купона");
      return;
    }
    try {
      const response = await axios.post(
        "https://api.alyonatestsite.store/api/check-coupon",
        { name: couponCode.trim() }
      );
      const data = response.data; 
      console.log(data)
      // Пример data: { appliesToAll: true/false, products: [id, id], discountPercent: 10 }
      setCouponData(data);
      setCouponError("");
    } catch (error) {
      setCouponError("Купон не найден или недействителен");
      setCouponData(null);
    }
  };
  
  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const validateForm = () => {
    const requiredFields = ["initials", "phone", "email", "country", "city"];
    const isBasicFieldsFilled = requiredFields.every((field) => formData[field]);
    if (deliveryMethod === "136") {
      return isBasicFieldsFilled && formData.deliveryPoint;
    } else if (deliveryMethod === "137") {
      return isBasicFieldsFilled && formData.address && formData.apartment && formData.floor;
    }
    return false;
  };
  // if (cartItems.length === 0) {
  //   return (
  //     <div className="flex flex-col min-h-screen bg-white">
  //       <Header />
  //       <div className="flex-grow flex flex-col w-full justify-center items-center mt-24 py-12">
  //         <h1 className="font-lack text-4xl sm:text-5xl text-black text-center">Корзина</h1>
  //         <div className="flex flex-col lg:flex-row w-full max-w-7xl mt-12 space-y-8 lg:space-y-0 lg:space-x-8 px-4">
  //           <div className="flex-[2] bg-sky-100 p-4 sm:p-6 rounded-lg shadow-md">
  //             <h2 className="font-lack text-2xl sm:text-3xl mb-4">Ваши товары</h2>
  //             <div className="mt-8">
  //               <p className="font-lack text-lg">
  //                 Их нет. Пора бы это исправить! :)
  //               </p>
  //             </div>
  //           </div>
  //           <div className="flex-[1] bg-white p-4 sm:p-6 rounded-lg shadow-md">
  //             <h2 className="font-lack text-2xl sm:text-3xl w-3/4">Оформление доставки</h2>
  //             <form className="mt-8 space-y-4">
  //               <input
  //                 type="text"
  //                 name="initials"
  //                 required={true}
  //                 value={formData.initials}
  //                 onChange={handleInputChange}
  //                 disabled={true}
  //                 placeholder="ФИО"
  //                 className="w-full p-2 border rounded"
  //               />
  //               <input
  //                 type="text"
  //                 name="phone"
  //                 required={true}
  //                 disabled={true}
  //                 value={formData.phone}
  //                 onChange={handleInputChange}
  //                 placeholder="Номер телефона"
  //                 className="w-full p-2 border rounded"
  //               />
  //               <input
  //                 type="text"
  //                 name="email"
  //                 required={true}
  //                 disabled={true}
  //                 value={formData.email}
  //                 onChange={handleInputChange}
  //                 placeholder="Почта"
  //                 className="w-full p-2 border rounded"
  //               />
  //               <select
  //                 name="country"
  //                 required={true}
  //                 disabled={true}
  //                 value={formData.country}
  //                 onChange={handleInputChange}
  //                 className="w-full p-2 border rounded"
  //               >
  //                 <option value="">Выберите страну</option>
  //                 <option value="Россия">Россия</option>
  //                 <option value="Казахстан">Казахстан</option>
  //                 <option value="Беларусь">Беларусь</option>
  //               </select>
  //               <input
  //                 type="text"
  //                 name="city"
  //                 required={true}
  //                 disabled={true}
  //                 value={formData.city}
  //                 onChange={handleInputChange}
  //                 placeholder="Город"
  //                 className="w-full p-2 border rounded"
  //               />
  //               <div className="flex items-center space-x-4">
  //                 <label className="flex items-center space-x-2">
  //                   <input
  //                     type="radio"
  //                     name="deliveryMethod"
  //                     value="136"
  //                     checked={deliveryMethod === "136"}
  //                     onChange={handleDeliveryMethodChange}
  //                   />
  //                   <span>Пункт выдачи СДЭК</span>
  //                 </label>
  //                 <label className="flex items-center space-x-2">
  //                   <input
  //                     type="radio"
  //                     name="deliveryMethod"
  //                     value="137"
  //                     checked={deliveryMethod === "137"}
  //                     onChange={handleDeliveryMethodChange}
  //                   />
  //                   <span>Курьер</span>
  //                 </label>
  //               </div>
  //             </form>
  //             {pickupPoints.length > 0 && deliveryMethod === "136" && (
  //               <div className="mt-8">
  //                 <h2 className="text-xl sm:text-2xl mb-2 font-lack">Выберите пункт выдачи</h2>
  //                 <select
  //                   className="w-full p-2 border rounded"
  //                   onChange={(e) =>
  //                     setFormData((prev) => ({
  //                       ...prev,
  //                       deliveryPoint: e.target.key,
  //                     }))
  //                   }
  //                 >
  //                   <option value="">Выберите пункт...</option>
  //                   {pickupPoints
  // .slice()
  // .sort(sortByPickupCode)
  // .map((point) => (
  //                       <option key={point.code} value={point.location.address}>
  //                         {`${point.code} ${point.location.city}, ${point.location.region} - ${point.location.address}`}
  //                       </option>
  //                     ))}
  //                 </select>
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //       <Footer />
  //     </div>
  //   );
  // }
  const handleQuantityChange = async (id, size, quantity) => {
    setQuantityLoading(true);
    const product = products.find((item) => item.id === id);
    const maxStock = size
      ? product.sizes?.find((s) => s.name === size)?.quantity || 0
      : product.stock;
    if (quantity > 0 && quantity <= maxStock) {
      await updateCartItem(id, size, quantity);
    } else {
      notify({
        title: "Ошибка изменения количества товара",
        message: `Возможно, вы пытаетесь добавить товара больше, чем есть на складе, либо уменьшить минимальное количество.`,
        type: "error",
      });
    }
    setQuantityLoading(false);
  };
  const handleRemoveItem = (id, size) => {
    removeCartItem(id, size);
  };

  const LoadingOverlay = () => {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white p-6 rounded-lg shadow-lg text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600 mx-auto"></div>
          <p className="mt-4 text-lg font-lack">Идёт перенаправление на страницу оплаты...</p>
        </div>
      </div>
    );
  };

//   return (
// <div className="flex flex-col min-h-screen bg-white">
//     <Header page="merch" />
//     <div className="flex-grow">
//       {modalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-6 rounded-lg shadow-lg text-center">
//             <h2 className="text-xl font-bold">Некоторые товары были удалены</h2>
//             <ul className="mt-4 text-red-500">
//               {removedItems.map((item, index) => (
//                 <li key={index}>{item}</li>
//               ))}
//             </ul>
//             <button
//               onClick={() => setModalOpen(false)}
//               className="mt-4 bg-sky-500 text-white px-4 py-2 rounded-lg"
//             >
//               Окей
//             </button>
//           </div>
//         </div>
//       )}

//       {isPaymentLoading && <LoadingOverlay />}

//       <div className="flex flex-col w-full justify-center items-center mt-16 lg:mt-32 lg:py-12">
//         <h1 className="font-lack text-4xl sm:text-5xl text-black text-center">Корзина</h1>
//         <div className="flex flex-col lg:flex-row w-full max-w-7xl mt-12 space-y-8 lg:space-y-0 lg:space-x-8 px-4">
//           <div className="flex-[2] bg-sky-100 p-4 sm:p-6 rounded-lg shadow-md">
//             <h2 className="font-lack text-2xl sm:text-3xl mb-4">Ваши товары</h2>
//             <div className="mt-8 space-y-4">
//               {products.map((item) => (
//                 <div key={item.id} className="flex flex-row justify-between items-center border-b border-white pb-4">
//                   <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-2 lg:space-y-0 lg:space-x-4">
//                     <a href={`/merch/product/?id=${item.id}`}>
//                       <img
//                         src={`https://api.alyonatestsite.store${item?.images[0]}`}
//                         alt={item.name}
//                         className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-xl"
//                       />
//                     </a>
//                     <div className="flex flex-col">
//                       <a href={`/merch/product/?id=${item.id}`}
//                         className="font-lack text-lg sm:text-2xl hover:underline xl:w-5/6">{item.name}</a>
//                       <p className={`${!item.size && 'hidden'} text-sm sm:text-base`}>
//                         Выбор: {item.size}
//                       </p>
//                       <h1 className="font-lack">
//                         {item.discount && item.discount > 0 ? (
//                           <>
//                             <span className="bg-sky-600 px-1 text-white">{item.discount} руб.</span>{" "}
//                             <span className="line-through text-gray-500">{item.price} руб.</span>
//                           </>
//                         ) : (
//                           `${item.price} руб.`
//                         )}
//                       </h1>
//                       <div className="flex items-center space-x-4 mt-2">
//                         <button
//                           onClick={() => handleQuantityChange(item.id, item.size, item.quantity - 1)}
//                           className="px-2 py-1 bg-white rounded"
//                           disabled={quantityLoading}
//                         >
//                           -
//                         </button>
//                         {quantityLoading ? (
//                           <div className="h-6 w-10 bg-sky-200 relative overflow-hidden">
//                             <div className="absolute inset-0 bg-gradient-to-r from-sky-200 via-sky-100 to-sky-200 animate-shimmer"></div>
//                           </div>
//                         ) : (
//                           <span>{item.quantity}</span>
//                         )}
//                         <button
//                           onClick={() => handleQuantityChange(item.id, item.size, item.quantity + 1)}
//                           className="px-2 py-1 bg-white rounded"
//                           disabled={quantityLoading}
//                         >
//                           +
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="text-right">
//                     <p className="text-lg sm:text-2xl font-lack">
//                       {item.quantity *
//                         (item.discount && item.discount > 0
//                           ? item.discount
//                           : item.price)}{" "}
//                       руб.
//                     </p>
//                     <button
//                       onClick={() => handleRemoveItem(item.id, item.size)}
//                       className="mt-2 text-white bg-red-500 py-2 px-4 rounded"
//                     >
//                       Удалить
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//           <div className="flex-[1] flex flex-col space-y-6">
//   {/* Блок 1: Заполнение данных */}
//   <div className="bg-white p-6 rounded-2xl shadow-lg space-y-4">
//     <h2 className="font-lack text-2xl sm:text-3xl">Оформление доставки</h2>

//     <div className="p-4 rounded-xl font-lack bg-sky-400 bg-opacity-30">
//       Обратите внимание, что сбор и доставка товара может занимать от 2 до 4 недель. Вопросы касаемо заказов можно задать в нашей{" "}
//       <a href="https://t.me/alyonashvetsmerch_bot" target="_blank" rel="noreferrer" className="text-sky-600 hover:text-sky-400 hover:underline">
//         технической поддержке
//       </a>
//     </div>

//     <form className="space-y-4">
//       {/* Inputs */}
//       <input type="text" name="initials" value={formData.initials} onChange={handleInputChange} required placeholder="ФИО" className="w-full p-2 border rounded" />
//       <input type="phone" name="phone" value={formData.phone} onChange={handleInputChange} required placeholder="Номер телефона" className="w-full p-2 border rounded" pattern="^\+?[0-9]{10,15}$" />
//       <input type="text" name="email" value={formData.email} onChange={handleInputChange} required placeholder="Почта" className="w-full p-2 border rounded" pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$" />
//       <select name="country" value={formData.country} onChange={handleInputChange} required className="w-full p-2 border rounded">
//         <option value="">Выберите страну</option>
//         <option value="Россия">Россия</option>
//         <option value="Казахстан">Казахстан</option>
//         <option value="Беларусь">Беларусь</option>
//       </select>
//       <input type="text" name="city" value={formData.city} onChange={handleInputChange} required placeholder="Город" className="w-full p-2 border rounded" />

//       {/* Способ доставки */}
//       <div className="flex space-x-4">
//         <label className="flex items-center space-x-2">
//           <input type="radio" name="deliveryMethod" value="136" checked={deliveryMethod === "136"} onChange={(e) => setDeliveryMethod(e.target.value)} />
//           <span>Пункт выдачи СДЭК</span>
//         </label>
//         <label className="flex items-center space-x-2">
//           <input type="radio" name="deliveryMethod" value="137" checked={deliveryMethod === "137"} onChange={(e) => setDeliveryMethod(e.target.value)} />
//           <span>Курьер</span>
//         </label>
//       </div>

//       {/* Пункт выдачи или адрес */}
//       {pickupPoints.length > 0 && deliveryMethod === "136" && (
//         <select className="w-full p-2 border rounded" value={formData.deliveryPoint} onChange={(e) => setFormData({ ...formData, deliveryPoint: e.target.value })}>
//           <option value="">Выберите пункт...</option>
//           {pickupPoints
//             .slice()
//             .sort(sortByPickupCode)
//             .map((point) => (
//               <option key={point.code} value={point.code}>
//                 {`${point.code} | ${point.location.city}, ${point.location.region} - ${point.location.address}`}
//               </option>
//             ))}
//         </select>
//       )}

//       {deliveryMethod === "137" && (
//         <div className="space-y-2">
//           <AsyncSelect cacheOptions required loadOptions={debouncedAddressSearch} onChange={(selected) => setFormData({ ...formData, address: selected.label, city: selected.value.city, country: selected.value.country })} placeholder="Введите адрес" className="w-full rounded" />
//           <div className="flex space-x-4">
//             <input type="text" name="apartment" value={formData.apartment || ""} onChange={(e) => setFormData({ ...formData, apartment: e.target.value })} placeholder="Квартира" className="w-1/2 p-2 border rounded" />
//             <input type="text" name="floor" value={formData.floor || ""} onChange={(e) => setFormData({ ...formData, floor: e.target.value })} placeholder="Этаж" className="w-1/2 p-2 border rounded" />
//           </div>
//         </div>
//       )}
//     </form>
//   </div>

//   {/* Блок 2: Промокод и подытог */}
// <div className="bg-white p-6 rounded-2xl shadow-lg space-y-4">
//   <div className="space-y-1">
//     <div className="flex flex-wrap items-center gap-2">
//       <span className="font-lack">Подытог:</span>
//       <span className={`font-lack text-lg ${discountAmount > 0 && 'line-through text-gray-500'}`}>{totalAmount} руб.</span>
//       <span className={`font-lack text-lg ${discountAmount == 0 && 'hidden'} text-sky-500`}>{totalAmount - discountAmount} руб.</span>
//     </div>

//     {discountAmount > 0 && (
//       <div className="flex items-center space-x-2 bg-sky-100 text-black font-lack px-3 py-2 rounded-lg duration-300">
//         <span>Скидка по промокоду <strong className="text-sky-500">{couponData?.name}</strong>:</span>
//         <span className="text-sky-600">–{discountAmount} руб.</span>
//       </div>
//     )}
//   </div>

//   <p className="font-lack text-gray-600">
//     {isDeliveryCostLoading
//       ? "Расчет стоимости доставки..."
//       : formData.address || cityID
//       ? `Стоимость доставки: ${deliveryCost !== null ? deliveryCost : 'не определена'} руб. (от ${deliveryDays[0]} до ${deliveryDays[1]} дней)`
//       : "Выберите способ доставки для подсчета стоимости"}
//   </p>

//   {/* Инпут промокода */}
//   {discountAmount === 0 && (
//     <div className="flex flex-col sm:flex-row sm:items-center gap-2">
//       <input
//         type="text"
//         placeholder="Введите код купона"
//         value={couponCode}
//         onChange={(e) => setCouponCode(e.target.value)}
//         className="border p-2 rounded w-full sm:w-auto flex-grow"
//       />
//       <button
//         onClick={applyCoupon}
//         className="bg-sky-600 hover:bg-sky-700 text-white px-4 py-2 rounded"
//       >
//         Применить
//       </button>
//     </div>
//   )}
//   {couponError && <p className="text-red-500">{couponError}</p>}
// </div>


//   {/* Блок 3: Итог и оплата */}
//   <div className="bg-white p-6 rounded-2xl shadow-lg space-y-4">
//     <p className="text-xl sm:text-3xl font-lack">Итог: {finalAmount} руб.</p>

//     <div className="flex items-start space-x-2">
//       <input type="checkbox" id="agreement" checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} />
//       <label htmlFor="agreement" className="text-sm text-gray-600">
//         Создавая заказ, вы соглашаетесь с{" "}
//         <a onClick={() => downloadFile(policy, 'alyonashvetspolicy.doc')} className="text-sky-500 cursor-pointer hover:underline">
//           Политикой обработки персональных данных
//         </a>,{" "}
//         <a onClick={() => downloadFile(oferta, 'oferta.rtf')} className="text-sky-500 cursor-pointer hover:underline">
//           Условиями оферты и возврата товара
//         </a>.
//       </label>
//     </div>

//     <button
//       onClick={handlePayment}
//       className={`w-full py-2 rounded text-white font-semibold ${
//         validateForm() && !isDeliveryCostLoading && isAgreed && deliveryCost !== null
//           ? "bg-green-500 hover:bg-green-600"
//           : "bg-gray-400 cursor-not-allowed"
//       }`}
//       disabled={!validateForm() || !isAgreed || isDeliveryCostLoading || isPaymentLoading || deliveryCost === null}
//     >
//       {isPaymentLoading ? (
//         <div className="flex items-center justify-center">
//           <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
//           <span className="ml-2">Перенаправление...</span>
//         </div>
//       ) : (
//         "Оплатить"
//       )}
//     </button>

//     <a
//       onClick={clearCart}
//       href="/merch/cart"
//       className="w-full inline-flex justify-center items-center bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded"
//     >
//       Очистить корзину
//     </a>
//   </div>
// </div>

//           </div>
//       </div>
//     </div>
//     <Footer />
//   </div>
//   );
  return (
    <div className="h-screen">
      <Header page="merch" fixed={true} transparent={false} />

      <div className="flex flex-col text-center space-y-8 justify-center items-center h-full bg-white p-8">
        <h1 className="text-4xl font-lack">
          На данный момент магазин закрыт
        </h1>
        <p className="text-center text-lg">
          Все активные заказы уже собраны и переданы в доставку. Следить за их статусом можно в СДЭК или в <a href="https://t.me/alyonashvetsmerch_bot" className="text-blue-400 hover:text-blue-200">Telegram-боте</a>.
        </p>

      </div>
      <Footer />
    </div>
  );
};
